import { colors, typography } from '@mehilainen/mds-tokens';
import { badgeClasses } from '@mui/material';
import { focusVisible, muiFocusVisibleCssClass } from '../shared';
// MATTI-TODO: No variants :(, cannot make large
export const getThemeTabs = (tokens) => ({
    MuiTab: {
        defaultProps: {
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: {
                fontSize: tokens.uiElementTabs.fontSize,
                fontWeight: typography.baseTypography.weight.Medium,
                lineHeight: typography.baseTypography.height.Small,
                color: colors.Gray800,
                textTransform: 'unset',
                [`& > .${badgeClasses.root}`]: {
                    paddingRight: '14px',
                },
                [`&${muiFocusVisibleCssClass}`]: Object.assign(Object.assign({}, focusVisible), { outlineOffset: '-8px', borderRadius: '18px' }),
                '&.Mui-selected': {
                    color: colors.Gray900,
                },
                '&.Mui-disabled': {
                    color: colors.Gray500,
                },
            },
            textColorPrimary: {
                color: colors.Gray900,
            },
        },
    },
    MuiTabs: {
        styleOverrides: {
            indicator: {
                height: '4px',
                backgroundColor: tokens.uiElementTabs.lineColor,
            },
        },
    },
});
